import React, { useEffect, useState } from 'react'
import { ReactComponent as BasePricingIcon } from 'assets/ActionBasedPricing.svg'
import { IconButton, Popover, List, ListItem, ListItemText, Box, Divider, SvgIcon, Stack } from '@mui/material'
import { useLazyGetActionPricesForCSQuery } from 'api/configured-service/actionBasedPricingCrud'
import PropTypes from 'prop-types'
import { capitalize } from 'lodash'
import T from 'T'
import ServiceActionTypeChip from 'components/services/ServiceActionTypeChip'
import HHDisplayMoney from 'components/common/HHDisplayMoney'
import { formatCentsToDollars } from 'utils/price'
import { HHAlert } from 'components/common/HHAlert'
import StyledBadge from 'components/notes/common/StyledBadge'

const ActionBasedPricingIcon = ({ configuredServiceId = '', count = 0 }) => {
  const [fetchActionBasedPricingList, { data: actionBasedPricingList }] = useLazyGetActionPricesForCSQuery()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  useEffect(() => {
    if (configuredServiceId && open) {
      fetchActionBasedPricingList({ id: configuredServiceId })
    }
  }, [configuredServiceId, open])

  const handleMouseEnter = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMouseLeave = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <StyledBadge badgeContent={count} color="primary" invisible={count === 0}>
          <SvgIcon fontSize="small">
            <BasePricingIcon />
          </SvgIcon>
        </StyledBadge>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleMouseLeave}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        sx={{ pointerEvents: 'none' }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              maxWidth: 300,
              maxHeight: 400,
              overflow: 'auto',
            },
          },
        }}
      >
        {actionBasedPricingList && actionBasedPricingList.length > 0 ? (
          <List dense>
            {actionBasedPricingList.map((item, index) => (
              <ListItem disableGutters disablePadding key={index}>
                <ListItemText
                  primary={
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <ServiceActionTypeChip
                        variant="outlined"
                        action={item.actionType}
                        label={
                          <Stack direction="row" alignItems="center" gap={0.5} sx={{ width: '100%' }}>
                            {`${capitalize(item.actionType)}`}
                            <Divider orientation="vertical" flexItem color="primary.main" sx={{ width: '2px' }} />
                            <HHDisplayMoney value={formatCentsToDollars(item.priceCents, false)} formatToDollars={false} />
                          </Stack>
                        }
                        size="small"
                      />
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <HHAlert severity="info">{T.NO_ACTION_BASED_PRICING_AVAILABLE}</HHAlert>
        )}
      </Popover>
    </>
  )
}

ActionBasedPricingIcon.propTypes = {
  configuredServiceId: PropTypes.string,
}

export default ActionBasedPricingIcon
